import { render } from "./RepoDetails.vue?vue&type=template&id=ce9a92dc&scoped=true"
import script from "./RepoDetails.vue?vue&type=script&lang=js"
export * from "./RepoDetails.vue?vue&type=script&lang=js"

import "./RepoDetails.vue?vue&type=style&index=0&id=ce9a92dc&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce9a92dc"]])

export default __exports__